import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/auth/AuthContext";

/**
 * AdminDeleteButton — small trash button visible ONLY to admins.
 * Confirms via native dialog, calls DELETE endpoint, then invokes onDone.
 *
 * Props:
 *  - endpoint (string) e.g. "/leads/xyz"
 *  - label (string) shown in confirmation, e.g. "lead Amit Ltd."
 *  - onDone () => void
 *  - size ("sm"|"md")
 *  - testid (string)
 *  - variant ("icon"|"pill")
 */
export default function AdminDeleteButton({ endpoint, label = "this record", onDone, size = "sm", testid, variant = "icon" }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (user?.role !== "admin") return null;

  const doDelete = async (e) => {
    e?.stopPropagation?.();
    if (!window.confirm(`Delete ${label}? This cannot be undone.`)) return;
    setBusy(true);
    try {
      await api.delete(endpoint);
      toast.success("Deleted");
      onDone?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Delete failed");
    } finally { setBusy(false); }
  };

  if (variant === "pill") {
    return (
      <button
        type="button"
        onClick={doDelete}
        disabled={busy}
        className="inline-flex items-center gap-1 px-2 py-1 text-[10px] rounded-full text-[#B83A3A] hover:bg-[#FBEBE7] disabled:opacity-50"
        data-testid={testid}
        title={`Delete ${label}`}
      >
        <Trash2 size={11}/> Delete
      </button>
    );
  }

  const s = size === "md" ? 14 : 12;
  return (
    <button
      type="button"
      onClick={doDelete}
      disabled={busy}
      className={`p-1.5 text-[#B83A3A] hover:bg-[#FBEBE7] rounded ${busy?"opacity-50":""}`}
      data-testid={testid}
      title={`Delete ${label}`}
    >
      <Trash2 size={s}/>
    </button>
  );
}
